import { useComponentInstall } from '@/hooks/useComponentInstall';
import _Pkg from './Pkg';

export const Pkg = useComponentInstall(_Pkg);
export default Pkg;
export type { PkgProps } from './Pkg';
declare module 'vue' {
  interface GlobalComponents {
    FdaPkg: typeof Pkg;
  }
}
